"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('neural', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 33C22.466 33 23.2904 29.462 25 28.753C26.7723 28.0181 29.4174 30.0887 30.753 28.753C32.0887 27.4174 30.4474 24.4512 31.1823 22.6789C31.8912 20.9693 35 20.466 35 18.5C35 16.534 31.462 16.0591 30.753 14.3495C30.0181 12.5772 32.0887 9.58257 30.753 8.24695C29.4174 6.91134 26.2656 8.98185 24.4933 8.24695C22.7837 7.53805 22.466 4 20.5 4C18.534 4 18.0041 7.96462 16.2945 8.67352C14.5222 9.40842 11.5826 6.91134 10.247 8.24695C8.91134 9.58257 10.9819 12.2277 10.247 14C9.53805 15.7096 6 16.534 6 18.5C6 20.466 9.53805 20.9693 10.247 22.6789C10.9819 24.4512 8.91134 27.4174 10.247 28.753C11.5826 30.0887 14.5222 28.0181 16.2945 28.753C18.0041 29.462 18.534 33 20.5 33Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M20 22C22.2091 22 24 20.2091 24 18C24 15.7909 22.2091 14 20 14C17.7909 14 16 15.7909 16 18C16 20.2091 17.7909 22 20 22Z",
    fill: props.innerFillColor,
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M16.5692 30C15.3611 36.7989 16.0762 41.0543 18.7144 42.766C22.6719 45.3336 25.4482 43.3268 26.8968 41.8552C28.3454 40.3836 33.0495 33.9438 37.0763 33.9438C41.1031 33.9438 42.315 37.8241 41.9334 39.9438C41.679 41.357 41.022 42.4023 39.9624 43.0797",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;